"use client"
import { useState, useEffect } from "react"
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material"
import {
  Dashboard as DashboardIcon,
  ShoppingCart,
  Assessment,
  Settings,
  Factory,
  ExpandLess,
  ExpandMore,
  Group,
  Business,
  SupervisorAccount,
  Store,
  Person,
  PersonAdd,
  CalendarToday,
  AccountBalance,
  ChevronLeft, // Imported from @mui/icons-material
  ChevronRight, // Imported from @mui/icons-material
  PrecisionManufacturing, // For Manufacture
  Category, // For Product
} from "@mui/icons-material"
import { Link, useLocation } from "react-router-dom"

import React from "react";
import Can from "../../components/Can";

const menuItems = [
  { id: "dashboard", title: "Dashboard", icon: DashboardIcon, path: "/admin/dashboard", permission: "view-dashboard" },
  {
    id: "accounts",
    title: "Accounts",
    icon: AccountBalance,
    permission: "account.menu",
    subItems: [
      { id: "account-report", title: "Account Report", path: "/accounts/account-report", permission: "account.report" },
      { id: "profit-calculation", title: "Profit Calculation", path: "/accounts/profit-calculation", permission: "profitcalculation" },
      { id: "expense-manage", title: "Expense Manage", path: "/accounts/expense-manage", permission: "expense.manage" },
      { id: "deposit-manage", title: "Deposit Manage", path: "/accounts/deposit-manage", permission: "deposit.manage" },
      { id: "salary-manage", title: "Salary Manage", path: "/accounts/salary-manage", permission: "salary.manage" },
      { id: "payment-receive", title: "Payment Receive", path: "/accounts/payment-receive", permission: "payment.manage" },
      { id: "payment-out", title: "Payment Out", path: "/accounts/payment-out", permission: "payment.out" },
      { id: "payment-rec-report", title: "Payment Rec. Report", path: "/accounts/payment-rec-report", permission: "paymentreceive.report" },
      { id: "payment-out-report", title: "Payment Out Report", path: "/accounts/payment-out-report", permission: "paymentout.report" },
    ],
  },
  {
    id: "balance-sheet",
    title: "Balance Sheet",
    icon: Assessment,
    permission: "Balance Sheet Menu",
    subItems: [
      { id: "loan-receive", title: "Loan Receive", path: "/balance-sheet/loan-receive", permission: "Loan Receive" },
      { id: "loan-pay", title: "Loan Pay", path: "/balance-sheet/loan-pay", permission: "Loan Pay" },
      { id: "fixed-assets", title: "Fixed Assets", path: "/balance-sheet/fixed-assets", permission: "Fixed Assets" },
      { id: "fa-purchase", title: "FA Purchase", path: "/balance-sheet/fa-purchase", permission: "FA Purchase" },
      { id: "balance-sheet-report", title: "Balance Sheet", path: "/balance-sheet/report", permission: "Balance Sheet SubMenu" },
    ],
  },

  {
    id: "sales",
    title: "Sales",
    icon: ShoppingCart,
    permission: "sales.menu",
    subItems: [
      { id: "order-manage", title: "Order Manage", path: "/sales/order-manage", permission: "order.manage" },
      { id: "sale-manage", title: "Sale Manage", path: "/sales/sale-manage", permission: "sale.manage" },
      { id: "all-sales-reports", title: "All Sales Reports", path: "/sales/all-sales-reports", permission: "sale.report" },
    ],
  },

  {
    id: "hrm",
    title: "HRM",
    icon: Group,
    permission: "hrm.menu",
    subItems: [
      { id: "supplier-manage", title: "Supplier Manage", icon: Business, path: "/hrm/supplier-manage", permission: "supplier.manage" },
      {
        id: "national-sales-manager",
        title: "N S Manager", // Changed from "National Sales Manager" to "N S Manager"
        icon: SupervisorAccount,
        path: "/hrm/national-sales-manager", permission: "supplier.manage"
      },

      { id: "regional-manager", title: "Regional Manager", icon: SupervisorAccount, path: "/hrm/regional-manager", permission: "nationalsale.manager" },
      { id: "area-manager", title: "Area Manager", icon: SupervisorAccount, path: "/hrm/area-manager", permission: "area.manager" },
      { id: "mpo-manage", title: "MPO Manage", icon: Store, path: "/hrm/mpo-manage", permission: "mpo.manage" },
      { id: "customer-manage", title: "Customer Manage", icon: Person, path: "/hrm/customer-manage", permission: "customer.manage" },
      { id: "employee-manage", title: "Employee Manage", icon: PersonAdd, path: "/hrm/employee-manage", permission: "employee.manage" },
      {
        id: "employee-attendance",
        title: "EmployeeAttendance",
        icon: CalendarToday,
        path: "/hrm/employee-attendance", permission: "attendance.manage"
      },
    ],
  },
  {
    id: "manufacture",
    title: "Manufacture",
    icon: PrecisionManufacturing,
    permission: "manufacture.menu",
    subItems: [
      { id: "raw-materials", title: "Raw Materials", path: "/manufacture/raw-material", permission: "raw.material" },
      { id: "raw-purchase-plan", title: "Raw Purchase Plan", path: "/manufacture/raw-purchase-plan", permission: "raw.purchaseplan" },
      { id: "raw-purchase-order", title: "Raw Purchase Order", path: "/manufacture/raw-purchase-order", permission: "purchaseraw.order" },
      { id: "purchase-raw-material", title: "Purchase RawMaterial", path: "/manufacture/purchase-raw-material", permission: "purchase.raw" },
      { id: "raw-purchase-report", title: "Raw Purchase Report", path: "/purchases/raw-purchases-reports", permission: "raw-purchase-report" },
      {
        id: "raw-material-stock-report",
        title: "RawMaterial Stock Report",
        path: "/manufacture/raw-material-stock-report", permission: "rawmaterial.stock"
      },
      {
        id: "raw-category-wise-stock",
        title: "Raw Category Wise Stock",
        path: "/manufacture/raw-category-wise-stock", permission: "rawmaterial.catstock"
      },
      { id: "manufacture-manage", title: "Manufacture Manage", path: "/manufacture/manufacture-manage", permission: "manufacture.manage" },
      { id: "packaging-manage", title: "Packaging Manage", path: "/manufacture/packaging-manage", permission: "product.package" },
      { id: "finished-good-stock", title: "Finished Good Stock", path: "/manufacture/finished-good-stock", permission: "finishedgood.stock" },
      {
        id: "production-cost-analysis",
        title: "Production Cost Analysis",
        path: "/manufacture/production-cost-analysis", permission: "costanalysis"
      },
    ],
  },
  {
    id: "product",
    title: "Product",
    icon: Category,
    permission: "product.menu",
    subItems: [
      { id: "product-manage", title: "Product Manage", path: "/product/product-manage", permission: "product.manage" },
      { id: "purchase-product", title: "Purchase Product", path: "/product/purchase-product", permission: "purchase.product" },
      { id: "purchase-order", title: "Purchase Order", path: "/product/purchase-order", permission: "Product Purchase Order" },
      { id: "stock-manage", title: "Stock Manage", path: "/product/stock-manage", permission: "stock.manage" },
      { id: "production-report", title: "Production Report", path: "/product/production-report", permission: "production.report" },
      { id: "product-stock-report", title: "Product Stock Report", path: "/product/product-stock-report", permission: "stock.report" },
    ],
  },
  {
    id: "role&permission",
    title: "Role&Permission",
    icon: Group,
    permission: "Role&Permission",
    subItems: [
      { id: "all-permission", title: "All Permission", path: "/admin/all_permission", permission: "all.permission", },
      {
        id: "add-permission",
        title: "Add permission", // Changed from "National Sales Manager" to "N S Manager"
        path: "/admin/add_permission",
        permission: "add_permission",
      },
      { id: "all-roles", title: "All Roles", path: "/admin/all_role", permission: "all.roles", },
      {
        id: "add-roles",
        title: "Add roles", // Changed from "National Sales Manager" to "N S Manager"
        path: "/admin/add_role",
        permission: "add_role",
      },
      { id: "add-rolesinpermission", title: "AddRolesinPermission", path: "/admin/add_role_permission", permission: "addroles.permission", },
      { id: "all-rolesinpermission", title: "AllRolesinPermission", path: "/admin/all_role_permission", permission: "allroles.permission", },
    ],
  },
  {
    id: "admin",
    title: "Admin Manage",
    icon: Group,
    permission: "admin manage",
    subItems: [
      { id: "all-admin", title: "All Admin", icon: Business, path: "/admin/all_admin", permission: "all.admin" },
      {
        id: "add-admin",
        title: "Add Admin", // Changed from "National Sales Manager" to "N S Manager"
        icon: SupervisorAccount,
        path: "/admin/add_admin",
        permission: "add.admin"
      },

      { id: "all-multiadmin", title: "All MultiAdmin", icon: SupervisorAccount, path: "/admin/all_multi_admin", permission: "all.multiadmin" },
      { id: "add-multiadmin", title: "Add MultiAdmin", icon: SupervisorAccount, path: "/admin/add_multi_admin", permission: "add.multiadmin" },
      { id: "database_backup", title: "Database Backup", icon: SupervisorAccount, path: "/admin/database_backup", permission: "database.backup" },
    ],
  },

  {
    id: "settings",
    title: "Settings",
    icon: Settings,
    path: "/settings",
    permission: "addroles.permission",

  },
]

const SidebarContent = ({ open, isMobile, setSidebarOpen }) => {
  const location = useLocation()
  const [expandedMenus, setExpandedMenus] = useState([])

  // Effect to open the relevant submenu on page load/path change
  useEffect(() => {
    const currentPath = location.pathname
    let activeParentId = null

    for (const item of menuItems) {
      if (item.subItems) {
        if (item.subItems.some((subItem) => currentPath.startsWith(subItem.path))) {
          activeParentId = item.id
          break
        }
      } else if (item.path === currentPath) {
        // If a top-level item is active, ensure no submenu is expanded
        activeParentId = null
        break
      }
    }

    if (activeParentId) {
      setExpandedMenus([activeParentId]) // Only one parent ID in the array
    } else {
      setExpandedMenus([]) // Collapse all if no sub-menu is active or a top-level item is active
    }
  }, [location.pathname, menuItems]) // menuItems added to dependency array

  // Function to toggle menu expansion, ensuring only one is open at a time
  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => {
      if (prev.includes(menuId)) {
        // If the clicked menu is already open, close it
        return prev.filter((id) => id !== menuId)
      } else {
        // If the clicked menu is closed, open it and close all others
        return [menuId]
      }
    })
  }

  const handleMenuItemClick = () => {
    if (isMobile) {
      setSidebarOpen(false)
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Header section of the sidebar */}
      <Box sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <Factory color="primary" />
        {open && (
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              ERP System
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Management Panel
            </Typography>
          </Box>
        )}
        {isMobile && open && (
          <IconButton onClick={() => setSidebarOpen(false)} size="small" sx={{ ml: "auto" }}>
            <ChevronLeft />
          </IconButton>
        )}
      </Box>
      <Divider />
      {/* Menu Items List */}
      <List sx={{ pt: 1, flexGrow: 1, overflowY: "auto" }} className="custom-sidebar-scrollbar">
        {menuItems.map((item) => {
          const Icon = item.icon
          const hasSubItems = item.subItems && item.subItems.length > 0
          const isExpanded = expandedMenus.includes(item.id)
          const isActiveTopLevel = location.pathname === item.path // For top-level items

          return (
            <Can permission={item.permission} key={item.id}>
              <Box >
                {hasSubItems ? (
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => toggleMenu(item.id)}
                      sx={{
                        minHeight: 48,
                        // Parent menu button itself should not have a background when a sub-item is active
                        backgroundColor: "transparent",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)", // Lighter grey on hover
                        },
                        // No specific selected style for the parent button's background,
                        // as the active sub-item will provide the visual cue.
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: open ? 56 : "auto", justifyContent: "center" }}>
                        <Icon />
                      </ListItemIcon>
                      {open && (
                        <>
                          <ListItemText primary={item.title} />
                          {isExpanded ? <ExpandLess /> : <ExpandMore />}
                        </>
                      )}
                    </ListItemButton>
                  </ListItem>
                ) : (
                  <ListItem disablePadding>
                    <ListItemButton
                      component={Link}
                      to={item.path}
                      sx={{
                        minHeight: 48,
                        backgroundColor: isActiveTopLevel ? "rgba(0, 0, 0, 0.08)" : "transparent",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "rgba(0, 0, 0, 0.08)",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: open ? 56 : "auto", justifyContent: "center" }}>
                        <Icon />
                      </ListItemIcon>
                      {open && <ListItemText primary={item.title} />}
                    </ListItemButton>
                  </ListItem>
                )}
                {hasSubItems && open && (
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.subItems.map((subItem) => {
                        const SubIcon = subItem.icon
                        return (
                          <Can permission={subItem.permission} key={subItem.id}>
                            <ListItem disablePadding>
                              <ListItemButton
                                component={Link}
                                to={subItem.path}
                                sx={{
                                  pl: 4,
                                  backgroundColor:
                                    location.pathname === subItem.path ? "rgba(0, 0, 0, 0.08)" : "transparent",
                                  "&:hover": {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                                    "&:hover": {
                                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    },
                                  },
                                }}
                                onClick={handleMenuItemClick} // Close sidebar on mobile when sub-item is clicked
                              >
                                {SubIcon && (
                                  <ListItemIcon sx={{ minWidth: 40, justifyContent: "center" }}>
                                    <SubIcon sx={{ fontSize: 20 }} />
                                  </ListItemIcon>
                                )}
                                <ListItemText primary={subItem.title} />
                              </ListItemButton>
                            </ListItem>
                          </Can>
                        )
                      })}
                    </List>
                  </Collapse>
                )}
              </Box>
            </Can>
          )
        })}
      </List>
      <Divider sx={{ mt: "auto" }} />
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: open ? "flex-end" : "center",
          alignItems: "center",
        }}
      >
        <ListItemButton onClick={() => setSidebarOpen(!open)} sx={{ width: "auto", minHeight: 48 }}>
          {open ? <ChevronLeft /> : <ChevronRight />}
        </ListItemButton>
      </Box>
    </Box >
  )
}
export default SidebarContent
